import React from 'react';
import "../../../styles/CleanFabricaMob.css";

function CleanFabricaMob(props) {
  return (
    <div id="PFP_36_MoBPureFabrica_mob">
        <div id="PFP_36_MoBGroup_15132">
            <div id="PFP_36_MoBGroup_15050">
                <div id="PFP_36_MoBsocials_grp_shadow_space_websi">
		{props.data.linkedInUrl?
                    <div title="LinkedIn" id="PFP_36_MoBlinked_in_grp_shadow_space_web">
                        <svg class="PFP_36_MoBmed_shadow_space_website_7">
                            <ellipse id="PFP_36_MoBmed_shadow_space_website_7" rx="24" ry="24" cx="24" cy="24">
                            </ellipse>
                        </svg>
                        <div id="PFP_36_MoBlinked_in_shadow_space_website">
					<a href={props.data.linkedInUrl} target="_blank">
                            <svg class="PFP_36_MoBn_website_7_layout_" viewBox="-15.255 0 15.439 14.566">
                                <path id="PFP_36_MoBn_website_7_layout_" d="M -5.594671249389648 3.814697265625e-06 C -8.203055381774902 3.814697265625e-06 -9.837490081787109 1.412798166275024 -10.13955497741699 2.402577638626099 L -10.13955497741699 0.1386871188879013 L -15.2549991607666 0.1386871188879013 C -15.18850803375244 1.3406081199646 -15.2549991607666 14.56553649902344 -15.2549991607666 14.56553649902344 L -10.13955497741699 14.56553649902344 L -10.13955497741699 6.758750915527344 C -10.13955497741699 6.324968814849854 -10.16045379638672 5.891188621520996 -10.02873420715332 5.579627513885498 C -9.676643371582031 4.71206521987915 -8.921167373657227 3.811574220657349 -7.562833309173584 3.811574220657349 C -5.78718090057373 3.811574220657349 -4.979146957397461 5.145845413208008 -4.979146957397461 7.100076198577881 L -4.979146957397461 14.56553649902344 L 0.1837937831878662 14.56553649902344 L 0.1837937831878662 6.543442726135254 C 0.1837937831878662 2.075184345245361 -2.358731746673584 3.814697265625e-06 -5.594671249389648 3.814697265625e-06">
                                </path>
                            </svg>
                        </a>
                            <svg class="PFP_36_MoBlinked_in_i_shadow_space_websi" viewBox="0.931 -22.783 4.553 14.427">
                                <path id="PFP_36_MoBlinked_in_i_shadow_space_websi" d="M 0.9310000538825989 -8.35551643371582 L 5.484113693237305 -8.35551643371582 L 5.484113693237305 -22.78300476074219 L 0.9310000538825989 -22.78300476074219 L 0.9310000538825989 -8.35551643371582 Z">
                                </path>
                            </svg>
                            <svg class="PFP_36_MoBtop_dot_i_shadow_space_website" viewBox="-4.392 0 5.527 5.006">
                                <path id="PFP_36_MoBtop_dot_i_shadow_space_website" d="M -1.610737085342407 0 C -3.292033195495605 0 -4.392000198364258 1.079702377319336 -4.392000198364258 2.505163192749023 C -4.392000198364258 3.902759790420532 -3.323695659637451 5.005893707275391 -1.675329208374023 5.005893707275391 L -1.642399907112122 5.005893707275391 C 0.06929254531860352 5.005893707275391 1.135063052177429 3.898960590362549 1.135063052177429 2.50072979927063 C 1.10213315486908 1.077169299125671 0.06929254531860352 0 -1.610737085342407 0">
                                </path>
                            </svg>
                        </div>
                    </div>
			:""}
			{props.data.instagramUrl?	
                    <div title="Instagram" id="PFP_36_MoBInsta_grp_shadow_space_website">
                        <svg class="PFP_36_MoBshadow_space_website_7">
                            <ellipse id="PFP_36_MoBshadow_space_website_7" rx="24" ry="24" cx="24" cy="24">
                            </ellipse>
                        </svg>
				<a href={props.data.instagramUrl} target="_blank">
                        <img id="PFP_36_MoBinstagramshadow_space_website_" src="./Themes/CleanFabrica/instagramshadow_space_website_.png" srcset="./Themes/CleanFabrica/instagramshadow_space_website_.png 1x" />
                            
                        </a>
                    </div>:""}
			{props.data.whatsAppNumber?
                    <div title="WhatsApp" id="PFP_36_MoBwhatsapp_grp_shadow_space_webs">
                        <svg class="PFP_36_MoBmed_shadow_space_website_7_">
                            <ellipse id="PFP_36_MoBmed_shadow_space_website_7_" rx="24" ry="24" cx="24" cy="24">
                            </ellipse>
                        </svg>
                        <a href={"https://api.whatsapp.com/send?phone="+props.data.whatsAppNumber.substring(props.data.whatsAppNumber.length-10)} target="_blank">
				<img id="PFP_36_MoBwhatsapp_lbl_shadow_space_webs" src="./Themes/CleanFabrica/whatsapp_lbl_shadow_space_webs.png" srcset="./Themes/CleanFabrica/whatsapp_lbl_shadow_space_webs.png 1x" />
                           </a> 
                    </div>:""}
                </div>
                <div id="PFP_36_MoBn_234567890_mobile_number_shad">
                    <span>{props.data.businessPhone}</span>
                </div>
                <div id="PFP_36_MoBaffanghanioperatelive_email_sh">
                    <span>{props.data.businessEmail}</span>
                </div>
                <div id="PFP_36_MoBaddress_med_shadow_space_websi">
                    <span>{props.data.businessAddress}</span>
                </div>
                <img id="PFP_36_MoBlocation_img_shadow_space_webs" src="./Themes/CleanFabrica/location_img_shadow_space_webs.png" srcset="./Themes/CleanFabrica/location_img_shadow_space_webs.png 1x" />
                    
                <img id="PFP_36_MoBemail_address_shadow_space_web" src="./Themes/CleanFabrica/email_address_shadow_space_web.png" srcset="./Themes/CleanFabrica/email_address_shadow_space_web.png 1x" />
                    
                <img id="PFP_36_MoBphone_number_shadow_space_webs" src="./Themes/CleanFabrica/phone_number_shadow_space_webs.png" srcset="./Themes/CleanFabrica/phone_number_shadow_space_webs.png 1x" />
                    
                <div id="PFP_36_MoBn_Copyright_Operate_Live_OPC_P">
                    <span>© Copyright Operate Live (OPC) Private Limited.<br/> All Rights Reserved</span>
                </div>
                <div id="PFP_36_MoBContact_Us">
                    <span>Contact Us!</span>
                </div>
            </div>
            <iframe src={"https://maps.google.com/maps?width=100%25&height=600&hl=en&q="+((props.data.mapLatitude && (props.data.mapLatitude.toString()).length > 0)?props.data.mapLatitude.toString():"13.027696798394835")+","+((props.data.mapLongitude && (props.data.mapLongitude.toString()).length > 0)?props.data.mapLongitude.toString():"77.61844225211368")+"&t=&z=20&ie=UTF8&iwloc=B&output=embed&embedded=true;"} width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" class="PFP_36_MoBRectangle_757">
                <rect id="PFP_36_MoBRectangle_757" rx="0" ry="0" x="0" y="0" width="274" height="183">
                </rect>
            </iframe>
        </div>
        <div id="PFP_36_MoBGroup_15117">
            <img id="PFP_36_MoBplanetcare-23coWmkTNSg-unsplas" src="./Themes/CleanFabrica/planetcare-23coWmkTNSg-unsplas.png" srcset="./Themes/CleanFabrica/planetcare-23coWmkTNSg-unsplas.png 1x" />
                
            <svg class="PFP_36_MoBRectangle_748">
                <rect id="PFP_36_MoBRectangle_748" rx="0" ry="0" x="0" y="0" width="375" height="663">
                </rect>
            </svg>
            <img id="PFP_36_MoBAnime_Edit" src={props.data.imageUrl?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+(props.data.imageUrl.split('/')[5]):"./Themes/CleanFabrica/Anime_Edit.png"} />
                
            <div id="PFP_36_MoBYour_Business_Name">
                <span>{props.data.businessName}</span>
            </div>
            <div id="PFP_36_MoBDiscover_a_World_of_Possibilit">
                <span>"Discover a World of Possibilities<br/> in Every Brushstroke, with Our<br/>Exceptional Paints Adding Depth and <br/>Life to Your Imagination."</span>
            </div>
            <div id="PFP_36_MoBGroup_15113">
                <svg class="PFP_36_MoBRectangle_3">
                    <rect id="PFP_36_MoBRectangle_3" rx="24.5" ry="24.5" x="0" y="0" width="177" height="49">
                    </rect>
                </svg>
                <div id="PFP_36_MoBAvailable_Now">
                    <span>Available Now</span>
                </div>
            </div>
        </div>
        <div id="PFP_36_MoBGroup_15170">
            <div id="PFP_36_MoBScroll_Group_91">
    {props.offeringsData.map((off,idx)=>(
                <div id="PFP_36_MoBGroup_15144">
                    <svg class="PFP_36_MoBRectangle_754">
                        <rect id="PFP_36_MoBRectangle_754" rx="10" ry="10" x="0" y="0" width="187" height="270">
                        </rect>
                    </svg>
                    <img id="PFP_36_MoBannie-spratt-aJN7zURQ1Wg-unspl" src={off.defaultOfferingsImageUrl?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+(off.defaultOfferingsImageUrl.split('/')[5]):"./Themes/CleanFabrica/annie-spratt-aJN7zURQ1Wg-unspl.png"} />
                        
                    <div id="PFP_36_MoBTitle">
                        <span>{off.offeringTitle}</span>
                    </div>
                </div>))}
            </div>
            <div id="PFP_36_MoBGroup_15149">
                <div id="PFP_36_MoBOur_Colours">
                    <span>Our Colours</span>
                </div>
                <div id="PFP_36_MoBGroup_15145">
                    <svg class="PFP_36_MoBRectangle_753">
                        <rect id="PFP_36_MoBRectangle_753" rx="0" ry="0" x="0" y="0" width="145" height="38">
                        </rect>
                    </svg>
                    <div id="PFP_36_MoBView_More">
                        <span>View More</span>
                    </div>
                </div>
            </div>
        </div>
        <div id="PFP_36_MoBGroup_15033">
            <img id="PFP_36_MoBengin-akyurt-yCYVV8-kQNM-unspl" src="./Themes/CleanFabrica/engin-akyurt-yCYVV8-kQNM-unspl.png" srcset="./Themes/CleanFabrica/engin-akyurt-yCYVV8-kQNM-unspl.png 1x" />
                
            <div id="PFP_36_MoBGroup_15038">
                <div id="PFP_36_MoBScroll_Group_28_b">
                    <div id="PFP_36_MoBIt_is_a_long_established_fact__b">
                        <span>{props.data.vision}</span>
                    </div>
                </div>
                <div id="PFP_36_MoBVISION_b">
                    <span>VISION</span>
                </div>
            </div>
        </div>
        <div id="PFP_36_MoBGroup_15175">
            <img id="PFP_36_MoBengin-akyurt-yCYVV8-kQNM-unspl_b" src="./Themes/CleanFabrica/engin-akyurt-yCYVV8-kQNM-unspl_b.png" srcset="./Themes/CleanFabrica/engin-akyurt-yCYVV8-kQNM-unspl_b.png 1x" />
                
            <div id="PFP_36_MoBGroup_15038_b">
                <div id="PFP_36_MoBScroll_Group_28_b">
                    <div id="PFP_36_MoBIt_is_a_long_established_fact__b">
                        <span>{props.data.mission}</span>
                    </div>
                </div>
                <div id="PFP_36_MoBVISION_b">
                    <span>MISSION</span>
                </div>
            </div>
        </div>
        <div id="PFP_36_MoBGroup_15176">
            <img id="PFP_36_MoBtowfiqu-barbhuiya-998DibZwpIc-" src="./Themes/CleanFabrica/towfiqu-barbhuiya-998DibZwpIc-.png" srcset="./Themes/CleanFabrica/towfiqu-barbhuiya-998DibZwpIc-.png 1x" />
                
            <div id="PFP_36_MoBGroup_15038_cb">
                <div id="PFP_36_MoBScroll_Group_28_cc">
                    <div id="PFP_36_MoBIt_is_a_long_established_fact__cd">
                        <span>{props.data.businessName}</span>
                    </div>
                </div>
                <div id="PFP_36_MoBVISION_ce">
                    <span>PRINCIPLES</span>
                </div>
            </div>
        </div>
    </div>
  )
}

export default CleanFabricaMob